/*
 @author: M.Wang
 Created by preference on 2023/01/10
*/

import Vue from 'vue'
import img from './components/img'
import Emitter from './mixins/emitter'
import gsapPlugin from './plugins/gsap'
import eventPlugin from './plugins/event'
import video from './components/video'
import bgDirective from './directives/bg'
import iaDirective from './directives/ia'
import EasySlider from 'vue-easy-slider'
import fSwiper from './components/f-swiper.vue'
import fSwiperMobile from './components/f-swiper-mobile.vue'
import fRow from './components/f-row'

Vue.config.productionTip = false

window.__preload__ = {}

Vue.use(gsapPlugin)
Vue.use(eventPlugin)
Vue.use(EasySlider)

Vue.mixin(Emitter)

Vue.directive('bg', bgDirective)
Vue.directive('ia', iaDirective)

Vue.component('f-row', fRow)
Vue.component('f-swiper', fSwiper)
Vue.component('f-swiper-mobile', fSwiperMobile)
Vue.component('m-img', img)
Vue.component('m-video', video)
